import React from "react";
import { Children } from "react";

export const BoxPresentacion = ({ titulo, children }) => {
  return (
    <div className="dash-presentacion">
      <div className="dash-presentacion-titulo">
        <div className="dash-presentacion-titulo-texto">{titulo}</div>
        <div className="dash-presentacion-titulo-barras">
          <div className="dash-presentacion-bl"></div>
          <div className="dash-presentacion-circle"></div>
          <div className="dash-presentacion-br"></div>
        </div>
      </div>
      {Children.map(children, (child) => (
        <div>{child}</div>
      ))}
    </div>
  );
};
